import { request } from '@umijs/max';

import { LoginRequest, UserResponse } from '@/types';

export async function login(payload: LoginRequest): Promise<UserResponse> {
  return request('auth/signIn', {
    data: payload,
    method: 'POST',
  });
}

export async function logout(): Promise<void> {
  return request('auth/signOut', {
    method: 'POST',
  });
}
